import CcavenueReportsContainer from "../../container/admin/ccavenue-reports";

const CcavenueReportsView = () => {
    return <CcavenueReportsContainer />;
};

export default CcavenueReportsView;
